"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _slicedToArray2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _InputFactory = _interopRequireDefault(require("../InputFactory"));
var _excluded = ["type", "label", "icon"];
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/InputInfoMerge/index.js";
function InputInfoMerge(_ref) {
  var _this = this;
  var fields = _ref.fields,
    label = _ref.label,
    onChange = _ref.onChange,
    onSubmit = _ref.onSubmit;
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    isEdit = _React$useState2[0],
    setEdit = _React$useState2[1];
  function _onSubmit(e) {
    e.preventDefault();
    setEdit(false);
    onSubmit(e);
  }
  function cancelClick() {
    setEdit(false);
  }
  if (isEdit) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "list-group-item text-nowrap text-truncate",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19,
        columnNumber: 13
      }
    }, /*#__PURE__*/_react["default"].createElement("form", {
      onSubmit: _onSubmit,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20,
        columnNumber: 17
      }
    }, Object.keys(fields).map(function (field) {
      var _fields$field = fields[field],
        type = _fields$field.type,
        label = _fields$field.label,
        icon = _fields$field.icon,
        options = (0, _objectWithoutProperties2["default"])(_fields$field, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label fs-sm mt-3",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 27,
          columnNumber: 37
        }
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: icon,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 28,
          columnNumber: 41
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "ms-2 fw-light",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29,
          columnNumber: 41
        }
      }, label)), /*#__PURE__*/_react["default"].createElement(_InputFactory["default"], Object.assign({
        type: type,
        field: field,
        onChange: onChange
      }, options, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 31,
          columnNumber: 37
        }
      })));
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "my-3 text-end",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 21
      }
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-primary fs-xs",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 25
      }
    }, "SAVE"), /*#__PURE__*/_react["default"].createElement("button", {
      onClick: cancelClick,
      className: "btn btn-light fs-xs ms-2",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 25
      }
    }, "CANCEL"))));
  }
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "list-group-item text-nowrap text-truncate",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-key",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 13
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ms-2 me-1 fw-light",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 13
    }
  }, label), /*#__PURE__*/_react["default"].createElement("span", {
    className: "fs-sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 13
    }
  }, "**********"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return setEdit(true);
    },
    className: "btn btn-link p-0 float-end fs-sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 13
    }
  }, "Change"));
}
var _default = exports["default"] = InputInfoMerge;